<div class="container text-center py-5" id="div_container_777ef58c">
  <div class="row" id="div_row_1d882bf9">
    <div class="col-md-12" id="div_col-md-12_6b5099d1">
      <h4 class="fz-40 fw-bold text-dark" id="h4_fz-40_4dc41c47">
        WE APOLOGIZE
      </h4>
      <p id="p_93a82aec">Your session has expired.</p>
    </div>

    <div class="col-md-12" id="div_col-md-12_a494fa7e">
      <div class="py-3" id="div_py-3_d912b80b">
        <p id="p_32cb708e">Want to try again?</p>

        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="showLoginModal()"
          aria-label="Begin a new search"
          id="button_btn_79fe6c50"
        >
          BEGIN NEW SEARCH
        </button>
      </div>
    </div>
  </div>
</div>
